import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
/* Helpers */
import { manageAssistant } from '../../../helpers/assistant';
import { handleAPIRequest } from '../../../helpers/handleAPIRequest';
import { getPartnerEndpoints } from '../../../helpers/settings/partnerEndpoints';
import { objectIsEmpty, getParameterFromUrl, getPixelData, getIfSpeedAppEnabled } from '../../../helpers/utils';
import { addItemToLS, getItemFromLS, deleteItemFromLS } from '../../../helpers/localStorage';
import { deleteItemFromSS } from '../../../helpers/sessionStorage';
import { simulation } from '../../../helpers/mocks/simulation';
import { initialSliderNormal } from '../../../helpers/mocks/sliders';
import { initFirstSimulation } from '../../../helpers/handleCurrentSimulationData';
/* Mocks */
import { mockTableNormal } from '../../../helpers/mocks/tables';
/* Redux */
import { useSelector, useDispatch } from 'react-redux';
import { 
  setAmountSliderThunk,
  setPaymentSliderThunk,
  setTableThunk,
  setTokenThunk,
  setModalThunk,
  setLoaderThunk,
  setCurrentSimulationThunk,
  setSkipSimulationThunk,
  setIsSpeedAppThunk
} from '../../../redux/actions/index';
/* Components */
import { Header } from '../../shared/Header';
import { Overlay } from '../../shared/Overlay';
import { Modal } from '../../shared/Modal';
import { MainContentWrapper } from '../../shared/MainContentWrapper';
import { PageHeading } from '../../shared/PageHeading';
import { LoanCategorySelector } from '../../shared/LoanCategorySelector';
import { Slider } from '../../shared/Slider';
import { RequestInfo } from '../../shared/RequestInfo';
import { BizmaticaHiddenForm } from '../../shared/BizmaticaHiddenForm';
import { SimulationButton } from '../../shared/SimulationButton';
import { Button } from '../../shared/Button';
import { RetrieveEstimateLink } from '../../shared/RetrieveEstimateLink';
import { Footer } from '../../shared/Footer';
import { ScrollArrows } from '../../shared/ScrollArrows';

export const Simulatore = (props) => {
  const history = useHistory();
  const location = useLocation();
  const { search = '' } = location;
  const returnPage = `/simulatore-commerciale.html${search}`;
  const initMockSimulation = history?.location?.state?.returnButtonClicked || false;
  
  const table = useSelector(state => state.table.complete);

  const dispatch = useDispatch();
  const setTable = (tableData) => dispatch(setTableThunk(tableData));
  const setToken = (token) => dispatch(setTokenThunk(token));
  const setModal = (modal, options) => dispatch(setModalThunk(modal, options));
  const setSkipSimulation = (skipSimulation) => dispatch(setSkipSimulationThunk(skipSimulation));
  const setCurrentSimulation = (currentSimulationData) => dispatch(setCurrentSimulationThunk(currentSimulationData));
  const setAmountSlider = (amountOptions) => dispatch(setAmountSliderThunk(amountOptions));
  const setPaymentSlider = (paymentOptions) => dispatch(setPaymentSliderThunk(paymentOptions));
  const setIsSpeedApp = (isSpeedApp) => dispatch(setIsSpeedAppThunk(isSpeedApp));
  const setLoader = (loaderVisibility) => dispatch(setLoaderThunk(loaderVisibility));
  
  const [skipRecap, setSkipRecap] = useState(false);

  /**
       * 
       * New section - added on 31/08/2023
       * 
       * 
       * Checking if token is elegible to P1M
       * 
       * 
       */
  const skipP1MCheckApi = (skipP1MCheck = false, token = null) => {
    if(!skipP1MCheck) {
      console.log('check token');
      const callbacks = {
        200: function(response) {
          //SpeedApp e redirect sono completamente scollegati
          //SpeedApp = può usare lo SPID
          //Può capitare il caso che sia SpeedApp, ma non necessiti un redirect
          //Anche il contrario è possibile
          const {
            SpeedApp = false,
            isEnabled = false,
            redirectUrl = null
          } = response.data;

          if(SpeedApp) {
            setIsSpeedApp(getIfSpeedAppEnabled(SpeedApp));
          }
          
          if(isEnabled) {
            if(redirectUrl && redirectUrl !== '') {
              window.location.href = redirectUrl;
            } else {
              console.log('redirect url not defined');
              setLoader(false);
            }
          } else {
            console.log(`user isn't eligible`);
            setLoader(false);
          }
        },
        400: function() { setLoader(false); },
        403: function() { setLoader(false); },
        404: function() { setLoader(false); },
        500: function() { setLoader(false); },
        default: function() { setLoader(false); },
      };

      setLoader(true);
      
      handleAPIRequest({
        method: 'POST',
        url: getPartnerEndpoints("compass").api.IsP1MEnabledByCseToken,
        data: {
          token
        },
        // `timeout` specifies the number of milliseconds before the request times out.
        // If the request takes longer than `timeout`, the request will be aborted.
        timeout: 10 * 1000, // default is `0` (no timeout)
      }, callbacks);
    } else {
      console.log('not checking token');
    }
  }

  useEffect(function() {
    let token = getParameterFromUrl("token");
    const ds = getParameterFromUrl("ds");
    const bizmaticaEndpointEnvironment = getParameterFromUrl("formaction");
    const skipRecap = getParameterFromUrl("SC_RICALCOLO");
    const skipSimulation = getParameterFromUrl("skipSimulation");
    const skipP1MCheck = getParameterFromUrl("skipP1M") || false;
    const isSpeedApp = getParameterFromUrl("SpeedApp") || false;

    deleteItemFromSS('redirectUrl');
    deleteItemFromSS('redirectToken');
    deleteItemFromLS('token');

    setIsSpeedApp(getIfSpeedAppEnabled(isSpeedApp));

    //If turning back from recap doesn't do these actions;
    //If skipping simulation doesn't do these actions;
    if(!initMockSimulation && !skipSimulation) {
      setCurrentSimulation({...simulation});
      setAmountSlider({...initialSliderNormal.amount});
      setPaymentSlider({...initialSliderNormal.payment});
    }

    //se mi arriva come parametro che è SpeedApp, è speedApp

    if (token) {
      addItemToLS('token', token);

      skipP1MCheckApi(skipP1MCheck, token);
    } else {
      token = getItemFromLS('token');
    }

    setToken(token);

    if (ds) {
      const simulatorIsDown = ds === "no" ? true : false;
      sessionStorage.setItem("simulatorIsDown", simulatorIsDown);
    }
    
    if (bizmaticaEndpointEnvironment) {
      sessionStorage.setItem("bizmaticaEndpointEnvironment", bizmaticaEndpointEnvironment);
    }

    if (skipRecap === "S") {
      setSkipRecap(true);
      sessionStorage.setItem("skipRecap", true);
    } else {
      sessionStorage.setItem("skipRecap", false);
    }

    if (skipSimulation === "true") {
      var outerSimulation = JSON.parse(sessionStorage.getItem('outerSimulation'));
      
      if (outerSimulation && !objectIsEmpty(outerSimulation)) {
        const { purpose, amount, payment, numberOfInstallments, TAN, TAEG, others } = outerSimulation;

        setSkipSimulation(true);

        //setAmountSlider({...amount, initialValue: { real: amount.min, shown: amount.current }, currentValue: { real: amount.min, shown: amount.current }});
        setAmountSlider({
          initialValue: { real: amount.min, shown: amount.current },
          currentValue: { real: amount.min, shown: amount.current }
        });
        //setPaymentSlider({...payment, initialValue: { real: payment.min, shown: payment.current }, currentValue: { real: payment.min, shown: payment.current }});
        setPaymentSlider({
          //...payment,
          min: -1000,
          max: -1000,
          initialValue: { real: payment.current, shown: payment.current }, 
          currentValue: { real: payment.current, shown: payment.current }
        });

        setCurrentSimulation({
          purpose: {
            index: purpose.index,
            icon: purpose.icon,
            text: purpose.text,
            code: purpose.code,
          },
          amount: {
            current: amount.current,
            min: amount.min,
            max: amount.max,
          },
          payment: {
            current: payment.current,
            min: payment.min,
            max: payment.max,
          },
          numberOfInstallments: {
            min: numberOfInstallments.min,
            max: numberOfInstallments.max,
          },
          TAN: {
            min: TAN.min,
            max: TAN.max,
          },
          TAEG: {
            min: TAEG.min,
            max: TAEG.max,
          },
          others: {
            transparencyDuty: others.transparencyDuty,
            administrationFees: others.administrationFees,
            administrationFeesMax: others.maxComm || others.administrationFeesMax,
            stampDuty: others.stampDuty,
            stampDutyMax: others.maxImpBollo || others.stampDutyMax,
          }
        });

        history.push(`/risultato-profilo-web.html${search}`);

        return;
      }
    }
  }, []);

  const goToRecapPage = function () {
    //Use to load the query parameters if turning back
    history.push(`/risultato-profilo-web.html${search}`, { returnPage });
  }

  useEffect(function() {
    getPixelData('/simulatore-commerciale.html');
    addItemToLS('homePage', returnPage);

    const fallbackCallbacks = {
      200: function(response) {
        const table = response.data;

        if (Array.isArray(table) && table.length) {
          setTable(table);
          initFirstSimulation(
            { 
              table, 
              logarithmicCurrentAmount: simulation.amount.value,
              skipSimulation: getParameterFromUrl("skipSimulation") === 'true'
            }, 
            {
              setCurrentSimulation,
              setPaymentSlider
            },
            !initMockSimulation
          );
        } else {
          console.warn("Table is an empty array");
        }
      },
      400: function() {},
      404: function() {
        if (window.location.hostname === "localhost") {
          setTable(mockTableNormal);
        }
      },
      500: function() {},
      default: function() {
        if (window.location.hostname === "localhost") {
          setTable(mockTableNormal);
        }
      },
    };

    const callbacks = {
      200: function(response) {
        const table = response.data;

        if (Array.isArray(table) && table.length) {
          setTable(table);
          initFirstSimulation(
            { 
              table, 
              logarithmicCurrentAmount: simulation.amount.value,
              skipSimulation: getParameterFromUrl("skipSimulation") === 'true' 
            }, 
            {
              setCurrentSimulation,
              setPaymentSlider
            },
            !initMockSimulation
          );
        } else {
          console.warn("Table is an empty array");
        }
      },
      400: function() {},
      403: function() {
        // Fallback
        handleAPIRequest({
          method: 'GET',
          url: getPartnerEndpoints("compass").api.tableFallback,
        }, fallbackCallbacks);
      },
      404: function() {
        if (window.location.hostname === "localhost") {
          setTable(mockTableNormal);
        }
      },
      500: function() {},
      default: function() {},
    };
    
    handleAPIRequest({
      method: 'GET',
      url: getPartnerEndpoints("compass").api.table,
    }, callbacks);

    manageAssistant();
  }, []);

  //Flushing history.state after using it;
  //mantaining query parameters (search)
  useEffect(function () {
    history.replace({ ...history.location, state: {} });
  }, []);

  return (
    <div className="wrapper">
      <Overlay
        modalTarget="moreInfo"
        clickEvent={
          function() {
            setModal('moreInfo', {
              isVisible: false,
            })
          }
        }
      >
        <Modal
          content={
            {
              text: ["I valori dei tassi (TAN e TAEG) rimarranno espressi come intervallo tra minimo e massimo, finchè non avremo preso in carico e valutato la tua richiesta.", <br key="1" />, "Per personalizzare la tua richiesta di prestito ti chiediamo quindi di fornirci maggiori informazioni."]
            }
          }
          button={
            {
              text: "Ok, ho capito",
              clickEvent: function() {
                setModal('moreInfo', {
                  isVisible: false,
                })
              },
            }
          }
        />
      </Overlay>
      <Header
        logo={
          { 
            image: './images/logo_compass.png',
            alt: 'Logo compass',
            redirect: `/simulatore${returnPage}`,
          }
        }
        isSimulator={true}
      />
      <MainContentWrapper isSimulator={true}>
        <PageHeading title="Richiedi il tuo prestito on-line, riceverai la risposta in 1 giorno" isSimulator={true}/>
        <LoanCategorySelector title="Qual è l'obiettivo del prestito?"/>
        <Slider table={table} type="amount" title="Che importo ti serve?" />
        <Slider table={table} type="payment" title="Che rata mensile vuoi pagare?" />
        <RequestInfo skipRecap={skipRecap} />
        { skipRecap ? 
          <BizmaticaHiddenForm returnUrl={window.location.href}>
            <SimulationButton />
          </BizmaticaHiddenForm> :
          <Button isSimulator={true} color="red" text="Calcola" clickEvent={goToRecapPage} />
        }
        <RetrieveEstimateLink />
      </MainContentWrapper>
      <Footer isSimulator={true} useBold={true} />
      <ScrollArrows isSimulator={true} />
    </div>
  );
}

export default Simulatore;
